import React from "react";
import styles from "./ProjectsCardComponent.module.scss";
import { Link, useNavigate } from "react-router-dom";
import DaysLeftComponent from "../UI/DaysLeftComponent/DaysLeftComponent";
import CategoryComponent from "../UI/CategoryComponent/CategoryComponent";
import OpeningsSVG from "../SVGComponents/OpeningsSVG";
// import { formatToINRCurrency } from "../../utils/constants";
// import BudgetSVG from "../SVGComponents/BudgetSVG";
import LocationSVG from "../SVGComponents/LocationSVG";
import Button from "../UI/Button/Button";
import ShortlistedComponent from "../UI/ShortlistedComponent/ShortlistedComponent";
// import cardLogo from "../../images/Card_Logo.png";
import { useSelector } from "react-redux";
import NoOfApplicantsComponent from "../UI/NoOfApplicantsComponent/NoOfApplicantsComponent";
import { serverFiles } from "../../utils/utils";
import ActiveStatusComponent from "components/UI/ActiveStatusComponent/ActiveStatusComponent";
import ClockSVG from "components/SVGComponents/ClockSVG";
import SandClockSVG from "components/SVGComponents/SandClockSVG";

const ProjectsCardComponent = ({ page, project }) => {
  const { userProfile } = useSelector((state) => state.userProfile);
  const applicationPage = "/my-applications";

  const navigate = useNavigate();

  const projectId = project?.jobId;
  const applicationId = project?.applicationNumber;

  const shortlistedAt = new Date(project?.shortlistedAt).toLocaleDateString(
    "en-GB",
    {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }
  );

  return (
    <Link
      to={
        page === applicationPage
          ? `/my-applications/${applicationId}`
          : project?.isActive
          ? `/projects/${projectId}`
          : `/projects`
      }
      className={styles.link_wrapper}
    >
      <section className={styles.project_card}>
        <section className={styles.project_category_section}>
          {/* <CategoryComponent
            // category={project?.category?.name || project?.company?.categoryName}
            category={
              project?.industry || project?.company?.industry
            }
          /> */}

          {page === applicationPage &&
            (project?.applicationStatus === "SHORTLIST" ? (
              <ShortlistedComponent date={shortlistedAt} />
            ) : (
              <></>
            ))}

          {page !== applicationPage && userProfile?.userType !== "CREATOR" ? (
            <>
              <div
                onClick={() =>
                  navigate(
                    project?.isActive ? `${projectId}/applicants` : "/projects"
                  )
                }
              >
                <NoOfApplicantsComponent
                  variant={"filled"}
                  applicants={project?.applicantCount}
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </section>
        <section className={styles.project_title_section}>
          <div className={styles.project_title_description}>
            <p className={styles.project_title}>{project?.jobTitle}</p>
            <p className={styles.project_company}>
              {project?.companyJobRespDto?.name || project?.company?.name}
            </p>
          </div>

          {/* <div className={styles.project_card_logo}>
            <img src={serverFiles(project?.company?.logo)} alt="" />
          </div> */}
        </section>
        <section className={styles.project_openings_budget}>
          <div className={styles.project_3_divs}>
            <div className={styles.project_openings}>
              <OpeningsSVG height={28} width={28} />
              <div>
                <p className={styles.project_openings_label}>Openings</p>
                <p className={styles.project_openings_number}>
                  {project?.noOfOpenings}
                </p>
              </div>
            </div>

            {/* {page !== applicationPage && (
              <div className={styles.project_budget}>
                <BudgetSVG height={28} width={28} />

                <div>
                  <p className={styles.project_budget_label}>Budget</p>
                  <p className={styles.project_budget_number}>
                    {formatToINRCurrency(project?.projectBudget)}
                  </p>
                </div>
              </div>
            )} */}
            <div className={styles.project_budget}>
              <LocationSVG height={28} width={28} />

              <div>
                <p className={styles.project_location_label}>Location</p>
                <p className={styles.project_location_details}>
                  {project?.cityName || project?.city?.name},{" "}
                  {project?.stateName || project?.state?.name}
                </p>
              </div>
            </div>
            <div className={styles.project_budget}>
              <SandClockSVG height={28} width={28} />

              <div>
                <p className={styles.project_location_label}>
                  Project Duration
                </p>
                <p className={styles.project_location_details}>
                  {project?.projectDuration
                    ? `${project?.projectDuration} day${
                        project?.projectDuration > 1 ? "s" : ""
                      }`
                    : "0 days"}
                </p>
              </div>
            </div>
          </div>
          {/* {page === "/projects" && userProfile?.userType !== "CREATOR" ? (
            
          ) : (
            ""
          )} */}
          {page === applicationPage && (
            <Link
              className="unstyledLink"
              to={`/my-applications/${project?.applicationNumber?.toLowerCase()}`}
            >
              <Button variant={"outlined"}>Review Application</Button>
            </Link>
          )}

          {userProfile?.companyResponseDto?.userType === "BUSINESS" && (
            <ActiveStatusComponent active={project?.isActive} />
          )}
        </section>
      </section>
    </Link>
  );
};

export default ProjectsCardComponent;
